import { useSelector } from 'react-redux'
import { NavigationTab } from './NavigationTab'
import { defineMessages, useIntl } from 'react-intl'
import { Link as ReactRouterLink } from 'react-router-dom'
import { NavigationTabProps } from '../../../types/navigation'
import { useTrackingContext } from '../../../providers/tracking'
import { Icon, Text } from '@homebotapp/hb-react-component-catalog'
import { selectRouteToCalculators } from '../../../store/selectors/routes'
import { GlobalTrackingEventLocation, TrackingEventConstants } from '../../../constants/tracking'

const MSG = defineMessages({
  calculators: {
    id: 'Calculators.calculatorsTab',
    defaultMessage: 'Calculators'
  }
})

export const CalculatorsTab = ({ isSelected, ...tabProps }: NavigationTabProps) => {
  const intl = useIntl()
  const calculatorsRoute = useSelector(selectRouteToCalculators)

  // Used solely for legacy tracking event
  const { trackingClient } = useTrackingContext()

  const handleClick = () => {
    trackingClient?.buyerNavigationLinkClicked({
      buyer_navigation_link: TrackingEventConstants.CALCULATORS
    })
  }

  return (
    <NavigationTab
      {...tabProps}
      position='relative'
      as={ReactRouterLink}
      to={calculatorsRoute}
      onClick={handleClick}
      tracking={{
        guid: 'rXs6bkAovaG972Pisj6abE',
        descriptor: MSG.calculators.defaultMessage,
        ui_context: GlobalTrackingEventLocation.GLOBAL_NAVIGATION_BAR
      }}
    >
      <Icon
        name='calculator'
        data-qa='calculator'
        marginRight={['0', null, null, '2']}
        marginBottom={['1', null, null, '0']}
      />
      <Text as='span' fontWeight='semibold' sx={{ textWrap: 'nowrap' }} size={['3xs', 'sm']} m={0}>
        {intl.formatMessage(MSG.calculators)}
      </Text>
    </NavigationTab>
  )
}
